import styled from 'styled-components';
import { screenshotModeSidePadding } from 'src/components/ScreenshotMode/styled';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

const galleryWidth = 390;
const viewfinderPadding = 30;
const screenshotModeBottomPadding = 100;
const titleHeight = 115;
const titleBottomPadding = 24;

const calcMaxHeightOfViewfinder = `calc((100vw - ${screenshotModeSidePadding *
  2}px - ${viewfinderPadding}px - ${galleryWidth}px) * 2 / 3)`;
const calcMaxHeightByVerticalPadding = `calc(100% - ${screenshotModeBottomPadding}px)`;

export const GalleryContainer = styled('div')`
  position: relative;
  height: 100%;
  width: 390px;
  background-color: #f5f5f5;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  order: 2;

  @media not all and ${DEVICE.DESKTOP_PORTRAIT} {
    max-height: min(
      ${calcMaxHeightOfViewfinder},
      ${calcMaxHeightByVerticalPadding}
    );
  }

  @media ${DEVICE.DESKTOP_PORTRAIT} {
    flex: 1;
    width: unset;
    max-height: 100%;
    margin: 30px 0;
  }
`;

export const SpinnerContainer = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;

  svg path {
    fill: #333333;
  }
`;

export const TitleContainer = styled('div')`
  position: absolute;
  height: ${titleHeight}px;
  width: 100%;
  padding: 32px 40px ${titleBottomPadding}px;
  border-bottom: 1px solid #d5d5d5;
`;

export const Title = styled('h3')`
  height: 24px;
  margin: 0;
  font-family: Avenir Next;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 27px;
  color: #0d1a4c;
`;

export const Count = styled('div')`
  position: absolute;
  bottom: ${titleBottomPadding}px;
  height: 27px;
  font-size: 16px;
  line-height: 24px;

  color: #333333;
`;

export const ScreenshotsGallery = styled('div')`
  position: absolute;
  top: ${titleHeight}px;
  width: 100%;
  height: calc(100% - ${titleHeight}px);
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  align-items: flex-start;
  justify-content: space-between;
  align-content: flex-start;
  padding-bottom: 24px;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;

export const EmptyGalleryRow = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 32px 40px;
  align-items: center;
  text-align: center;
  font-size: 20px;
  line-height: 27px;
`;

export const EmptyImageContainer = styled('div')`
  position: relative;
  width: 150px;
  height: 100px;
  padding: 30px 20px;
  border: 1px dashed #bcbcbc;
  line-height: 18px;
  font-size: 12px;
  font-style: italic;
  color: #a7a7a7;
`;
